var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61424_19013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7141 2.45545H11.4284V1.32211C11.4284 1.11349 11.2578 0.944336 11.0474 0.944336C10.837 0.944336 10.6665 1.11349 10.6665 1.32211V2.45545H5.33312V1.32211C5.33312 1.11349 5.16255 0.944336 4.95217 0.944336C4.74179 0.944336 4.57122 1.11349 4.57122 1.32211V2.45545H2.28513C1.23361 2.45655 0.381487 3.30157 0.380371 4.34434V14.1666C0.381487 15.2093 1.23361 16.0543 2.28513 16.0554H13.7141C14.7656 16.0545 15.6179 15.2094 15.6188 14.1666V4.34434C15.6179 3.30153 14.7656 2.45642 13.7141 2.45545ZM14.8569 14.1666C14.8562 14.7922 14.345 15.2992 13.7141 15.2999H2.28513C1.65423 15.2992 1.14297 14.7922 1.14228 14.1666V7.74434H14.8569V14.1666ZM14.8569 6.98878H1.14228V4.34434C1.14297 3.71869 1.65423 3.21169 2.28513 3.211H4.57122V4.34434C4.57136 4.55282 4.74189 4.72225 4.95217 4.72211C5.16241 4.72198 5.33326 4.55287 5.33312 4.34434V3.211H10.6665V4.34434C10.6666 4.55282 10.8371 4.72225 11.0474 4.72211C11.2577 4.72198 11.4285 4.55287 11.4284 4.34434V3.211H13.7141C14.345 3.21169 14.8562 3.71869 14.8569 4.34434V6.98878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8569 14.1666C14.8562 14.7922 14.345 15.2992 13.7141 15.2999H2.28513C1.65423 15.2992 1.14297 14.7922 1.14228 14.1666V7.74434H14.8569V14.1666Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8569 6.98878H1.14228V4.34434C1.14297 3.71869 1.65423 3.21169 2.28513 3.211H4.57122V4.34434C4.57136 4.55282 4.74189 4.72225 4.95217 4.72211C5.16241 4.72198 5.33326 4.55287 5.33312 4.34434V3.211H10.6665V4.34434C10.6666 4.55282 10.8371 4.72225 11.0474 4.72211C11.2577 4.72198 11.4285 4.55287 11.4284 4.34434V3.211H13.7141C14.345 3.21169 14.8562 3.71869 14.8569 4.34434V6.98878Z",
    fill: "#635BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61424_19013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateActive);
export default __webpack_public_path__ + "static/media/DateActive.afb46d60dc8529d8ed0f6a8093e37abc.svg";
export { ForwardRef as ReactComponent };